import { LivePageWidget } from './root';

window.LivePageWidget = LivePageWidget;
